import { useAutoneTranslation } from '@autone/translations';
import { forwardRef } from 'react';

import { Button, type ButtonProps, cn } from '../../../../tailwind';
import { useChangeFiltersPopoverViewContext } from '../ChangeFiltersPopoverView.context';

export const SavedFiltersButton = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, ...props }, ref) => {
    const { common } = useAutoneTranslation();
    const [, dispatch] = useChangeFiltersPopoverViewContext();

    return (
      <Button
        variant="outlined"
        color="secondary"
        className={cn('h-8', className)}
        onClick={() => dispatch({ type: 'GO_TO', payload: 'saved' })}
        ref={ref}
        {...props}
      >
        {common('filters.saved-filters')}
      </Button>
    );
  },
);
